@switch(type$ | async){ @case(dialogType.LOGIN_REGISTER){
<login-register [tabIndex]="tabIndex"></login-register>
} @case(dialogType.REGISTER_AGREE){
<register-agree [callback]="registerAgree"></register-agree>
} @case(dialogType.LOGIN_2FA){
<verify-2fa
  header="Email Verification"
  title="Two Step verification"
  submitText="Confirm Email"
  sendType="Email"
  [email]="loginService.email"
  [otpType]="loginService.otpType"
  [isSpecificType]="true"
  [submitFunc]="loginService.verify2fa.bind(loginService)"
></verify-2fa>
} @case(dialogType.RESET_PASSWORD){
<reset-password></reset-password>
} @case(dialogType.RESET_PASSWORD_EMAIL){
<reset-password-email></reset-password-email>
}@case(dialogType.THIRD_PARTY){
<third-party></third-party>
} @case (dialogType.KYC) {
<kyc-dialog
  title="Sign up"
  [requireTerms]="loginService.needKyc"
  [requireEmail]="!loginService.email"
  [prefillEmail]="loginService.email"
  [loading]="kycLoading"
  (submitted)="onKycSubmit($event)"
  (closed)="onKycClose()"
></kyc-dialog>
} }
